import React, { FC, ReactNode } from 'react';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import { Theme } from 'evcharging/app/themes';

interface SectionTitleProps {
  children: ReactNode;
  variant?: 'h2' | 'p';
}

const SectionTitle: FC<SectionTitleProps> = (props) => {
  const { variant = 'h2', children } = props;
  const theme = useTheme();
  const styles = createStyles(theme);

  return variant === 'h2' ? (
    <h2 className={styles.root}>{children}</h2>
  ) : (
    <p className={styles.root}>{children}</p>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    font-weight: 700;
    font-size: 28px;
    line-height: 150%;
    color: #000000;
    ${theme.breakpoints.mobile.down} {
      font-size: 24px;
    }
  `,
});

export default SectionTitle;
